import { Button, message, Modal, Select, Spin, Tooltip } from "antd";
import { renderToStaticMarkup } from "react-dom/server";
import { createContext, ReactNode, useContext, useEffect, useState } from "react";
import agendorLogo from '../assets/crmLogos/agendor.png'
import pipedriveLogo from '../assets/crmLogos/pipedrive.png'
import piperunLogo from '../assets/crmLogos/piperun.png'
import rdStationLogo from '../assets/crmLogos/rdStation.png'
import bitrixLogo from '../assets/crmLogos/bitrix.png'
import hubspotLogo from '../assets/crmLogos/hubspot.png'
import { crmGetUserConnections } from "../lib/crmGetUserConnections";
import { crmSendLeads } from "../lib/crmSendLeads";
import { FaCheck } from "react-icons/fa";
import { MdOutlineWebhook } from "react-icons/md";
import { BiSolidError } from "react-icons/bi";
import { usePostHog } from "posthog-js/react";

interface CrmContext {
  selectedCrm: string | undefined;
  setSelectedCrm: (value: string) => void;
  sendToCrmButton: (modal: boolean, record: object) => JSX.Element | null;
  options: object[];
  connections: object[];
  setUpdateConnections: (value: number) => void
  setSelectedList: (value: object)=> void
}

interface CrmOption{
  label: string,
  value: string,
  crm: string,
  funnel: string,
  stage: string,
}

interface Connection{
  con_name: string,
  crm_name: string,
  con_token: string,
  con_funnel: string,
  con_stage: string,
  con_date: string,
  status: boolean
}

const CrmContext = createContext({} as CrmContext);

export const CrmProvider: React.FC<{ children: ReactNode }> = ({ children }) => {

    const [connections, setConnections] = useState<Connection[]>([])
    const [options, setOptions] = useState<CrmOption[]>([])
    const [updateConnections, setUpdateConnections] = useState<number>(Math.random())
    const [selectedList, setSelectedList] = useState<object | undefined> (undefined)
    const [loadingCrm, setLoadingCrm] = useState<boolean>(false)
    const [sendingRecord, setSendingRecord] = useState<object[]>([])
    const [successfulysentLeads, setSucessfulySentLeads] = useState<object[]>([])
    const [failedToSendLeads, setFailedToSendLeads] = useState<object[]>([])
    const posthog = usePostHog();
    useEffect(()=>{
      crmGetUserConnections().then(connections=>{
        if(!connections || !Array.isArray(connections.body)) return
        setConnections(connections.body);
      })
    },[updateConnections])

    useEffect(() => { 
      if(!connections) return
      const filteredOptions = connections
        .filter((connection) => connection.status)
        .map((connection) => ({
          label: connection.con_name,
          value: connection.con_name,
          crm: connection.crm_name,
          funnel: connection.con_funnel,
          stage: connection.con_stage,
        }));   
      setOptions(filteredOptions);
    }, [connections]);
    

  const [selectedCrm, setSelectedCrm] = useState<string | undefined>(undefined);
  const crmLogos={'agendor':agendorLogo, 'pipedrive':pipedriveLogo, 'piperun':piperunLogo, 'rdcrm':rdStationLogo, 'bitrix': bitrixLogo, 'hubspot': hubspotLogo, 
    'webhook': `data:image/svg+xml,${encodeURIComponent(renderToStaticMarkup(<MdOutlineWebhook size={40}/>))}`}


  const RenderSendToCrmIcon: React.FC<{ modal: boolean, listName: string, record: object }> = ({ modal, listName,record }) => {
    const [modalVisibility, setModalVisibility] = useState<boolean>(false);
    const selectedOption = options.filter((option)=>(option.value === selectedCrm))[0]
    const sendToCrm = ()=>{
      setLoadingCrm(true)
      setSendingRecord([...sendingRecord,record])
      const activeConnection = connections.filter(connection =>(connection.con_name === selectedOption.label))[0]
      
      crmSendLeads(selectedList ? selectedList.path : localStorage.getItem('leadPath'), activeConnection.crm_name,activeConnection.con_token,activeConnection.con_funnel,activeConnection.con_stage,record.cnpj_completo).then(response=>{
        if(response.statusCode === 200){
          if(record.cnpj_completo){
            message.success('Lead enviado com sucesso')
          }
          else{
            message.success('Lista enviada com sucesso')
          }
          setSucessfulySentLeads([...successfulysentLeads,record])
        }
        else{
          message.error(response.body)
          setFailedToSendLeads([...failedToSendLeads,record])
        }
        setLoadingCrm(false)
        setSendingRecord(sendingRecord.filter(value=>(value !== record)))
      })
    }
    
    return (
      <div>
        <Tooltip title={selectedOption.crm}>
          <div style={{display:'flex', flexDirection:'column',alignItems:'center'}}>
        {
          loadingCrm && sendingRecord?.includes(record)?
          <Spin/>
          :
          <Button
            icon={<img src={crmLogos[selectedOption.crm]} alt={selectedOption.crm} style={{transform:'scale(0.6)'}} />}
                  onClick={() => {
                    posthog.capture('send_to_crm_clicked_botao');
                    if (modal) {
                      setModalVisibility(true);
                    } else {
                      sendToCrm();
                    }
                  }}
            type="link"
            style={{ padding: 0 }}
          />
        }  
        {
          successfulysentLeads.includes(record)?
            <FaCheck color="#249882"/>
          :
          failedToSendLeads.includes(record)?
          <BiSolidError color="#fe6556"/>
          :
          <></>
        }
        </div>
        </Tooltip>
        <Modal
          title="Confirmar Envio"
          open={modalVisibility}
          onCancel={() => {
            posthog.capture('send_to_crm_modal_cancel_botao')
            setModalVisibility(false)
          }}
          onOk={() => {
            posthog.capture('send_to_crm_modal_confirm_botao')
            sendToCrm();
            setModalVisibility(false);
          }}
        >
          <p>Deseja enviar {listName} para {selectedCrm}?</p>
          <div style={{fontSize:'small'}}>
          {  
          selectedOption.crm === 'webhook' ? <></> :
          <><br /><p>Detalhes da conexão:</p><p>CRM: {selectedOption.crm}</p><p>Funil: {selectedOption.funnel}</p><p>Estágio: {selectedOption.stage}</p></>
          }
          </div>
        </Modal>
      </div>
    );
  };

  const sendToCrmButton = (modal: boolean, record: object) => {
    return selectedCrm === undefined ? null : (

      <RenderSendToCrmIcon modal={modal} listName={selectedList ? selectedList.id : localStorage.getItem('leadId') } record = {record}/>

    );
  };

  return (
    <CrmContext.Provider value={{ selectedCrm, setSelectedCrm, sendToCrmButton, options, connections, setUpdateConnections, setSelectedList }}>
      {children}
    </CrmContext.Provider>
  );
};

export const useCrm = () => {
  const context = useContext(CrmContext);
  return context;
};


